import { CombinedGraphQLErrors } from '@apollo/client';

import { type ErrorCode } from '@/adapters/graphql/errorCodes';

const hasGraphQLErrorCode = (error: unknown, code: ErrorCode): boolean => {
  if (!CombinedGraphQLErrors.is(error)) {
    return false;
  }

  return error.errors.some((err) => err.extensions?.['code'] === code);
};

export { hasGraphQLErrorCode };
